export default {"src":"/_next/static/media/GoogleIcon.972a5966.svg","height":600,"width":2025,"blurWidth":0,"blurHeight":0};